<div v-if="$route.name === 'create_assets'">
                  <button class="btn btn-primary btn-sm text-xxs rounded shadow mb-3" data-bs-toggle="modal"
                  data-bs-target="#create_community_asset_modal"
                  @click="open_create_modal">Create Assets</button>
</div>

<div v-else>
<!-- UPDATED FULL TEMPLATE (drop-in) -->
  <Loader :loading="isLoading" />
  <HomeNavBar />
  <InactivityModal />

  <div class="mx-auto scrollable-container">
    <div class="container-fluid">
      <!-- Tabs Navigation -->
      <div class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-9 h-100 overflow-auto mt-2">
          <div class="card-header bg-banner-gradient rounded card-header-primary p-2">
            <ul class="nav nav-tabs nav-justified w-100 border-0 text-xxs px-2 gap-0" role="tablist">
              <li class="nav-item text-center" role="presentation">
                <button
                  class="nav-link rounded-3 px-2 py-2 fw-500"
                  :class="{ active: activeTab === 'assets' }"
                  @click="activeTab = 'assets'"
                >
                  Assets
                </button>
              </li>
              <li class="nav-item text-center" role="presentation">
                <button
                  class="nav-link rounded-3 px-2 py-2 fw-500"
                  :class="{ active: activeTab === 'bookings' }"
                  @click="show_my_bookings"
                >
                  My Bookings
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Assets Tab -->
      <div v-if="activeTab === 'assets'" class="row justify-content-center">
        <div class="col-12 col-md-11 col-lg-9">
          <div class="d-flex">
            <button
              class="btn btn-sm nav-item text-xxs bg-primary text-white me-2 rounded dropdown-toggle ms-2 mt-2"
              @click="open_create_modal">
              Add asset
            </button>
            
          </div>

          <div class="event-group">
            <div class="d-flex align-items-center temporary-post" v-if="temporary_asset_post" id="temp-post">
              <p class="text-xxs fw-bold mb-0">Editing...</p>
              <div class="spinner-border ms-auto text-secondary" role="status" aria-hidden="true"></div>
            </div>
            <div v-if="community_assets.length === 0" class="text-center py-5">
            <div class="mb-4">
              <i class="bi bi-calendar-x text-muted fs-1"></i>
            </div>
            <h5 class="text-muted mb-3">No Assets Yet</h5>
            <p class="text-muted">You haven't added any assets yet. Please add your first asset to get started.</p>
          </div>
            <div v-else>
            <div
              v-for="community_asset in community_assets"
              :key="community_asset?.id"
              class="card event-card lh-sm mt-2 border-0 border-bottom-primary position-relative"
            >
              <div class="event-arrow"></div>
              <div class="card-body">
                <!-- Dots dropdown -->
                <div class="dropend float-end" @click.stop>
                  <button
                    type="button"
                    class="fw-bold text-dark btn btn-link p-0 text-decoration-none"
                    :id="`assetMenuBtn-${community_asset?.id}`"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-label="Asset actions"
                    v-if="current_role === 'admin' || community_asset.creater?.id === current_user_id"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu custom-dropdown lh-1" :aria-labelledby="`assetMenuBtn-${community_asset?.id}`">
                    <li v-if="current_role === 'admin' || community_asset.creater?.id === current_user_id">
                      <a class="dropdown-item text-xxs fw-bold" href="#"
                        @click.prevent="view_bookings(community_asset)"
                        data-bs-toggle="modal" data-bs-target="#bookingsListModal">
                        <i class="bx bx-calendar fs-6"></i> View Bookings
                      </a>
                    </li>
                    <li v-if="community_asset.creater?.id === current_user_id && !community_asset.is_booked">
                      <a class="dropdown-item text-xxs fw-bold" href="#" @click.prevent="edit_asset(community_asset)">
                        <i class="bx bxs-edit fs-6"></i> Edit
                      </a>
                    </li>
                    <li v-if="(current_role === 'admin' || community_asset.creater?.id === current_user_id) && !community_asset.is_booked">
                      <a class="dropdown-item text-xxs fw-bold" href="#" @click.prevent="delete_asset(community_asset.id)">
                        <i class="bx bxs-trash-alt fs-6"></i> Delete
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Asset info -->
                <p class="card-title fw-bold mb-1">{{ community_asset.name }}</p>
                <p class="text-muted text-xxs mb-3">
                  <i class="bi bi-geo-alt text-danger"></i> {{ community_asset.location }}
                </p>
                <button
                  type="button"
                  @click.stop="select_asset(community_asset)"
                  data-bs-toggle="modal"
                  data-bs-target="#assetModal"
                  class="btn btn-primary rounded text-xxs mt-0 me-2"
                >
                  See more
                </button>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      <!-- My Bookings Tab -->
      <div v-if="activeTab === 'bookings'" class="row justify-content-center mt-3">
        <div class="col-12 col-md-11 col-lg-9">
          <!-- Empty State -->
          <div v-if="my_bookings.length === 0" class="text-center py-5">
            <div class="mb-4">
              <i class="bi bi-calendar-x text-muted fs-1"></i>
            </div>
            <h5 class="text-muted mb-3">No Bookings Yet</h5>
            <p class="text-muted">You haven't made any bookings yet. Start exploring our assets!</p>
          </div>

          <!-- Bookings List -->
          <div v-else>
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h4 class="mb-0">My Bookings</h4>
              <span class="badge bg-primary text-light text-xxs">
                {{ my_bookings.length }} booking{{ my_bookings.length !== 1 ? 's' : '' }}
              </span>
            </div>

            <div class="row g-3">
              <!-- Group bookings by asset -->
              <div v-for="(group, assetId) in grouped_Bookings" :key="assetId" class="col-12">
                <div class="card shadow-sm border-0 h-100">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <!-- Asset Info -->
                      <div class="col-md-4 mb-3 mb-md-0 text-xxs">
                        <p class="mb-1 fw-bold text-xxs">{{ group.latest.asset }}</p>
                      </div>

                      <!-- Date & Time Info -->
                      <div class="col-md-4 mb-3 mb-md-0 position-relative">
                        <div class="text-center text-md-start text-xxs">
                          <!-- Calendar & Date -->
                          <div class="mb-2 d-flex align-items-center">
                            <i
                              class="bi bi-calendar3 text-muted me-2 cursor-pointer"
                              :ref="`calendarIcon-${assetId}`"
                              @click.stop="toggle_calendar_popover(assetId)"
                              title="View Booking History"
                            ></i>
                            <span class="fw-medium">{{ group.latest.booking_start_date }}</span>
                          </div>

                          <!-- Clock & Time -->
                          <div>
                            <i class="bi bi-clock text-muted me-2"></i>
                            <span class="text-muted small">
                              {{ formatTime(group.latest.booking_start_time) }} - {{ formatTime(group.latest.booking_end_time) }}
                            </span>
                          </div>
                        </div>

                        <!-- Popover -->
                        <transition name="fade">
                          <div
                            v-if="calendar_popover_id === assetId"
                            :ref="`calendarPopover${assetId}`"
                            class="popover popover-lg bs-popover-bottom show bg-white border rounded shadow-sm p-3 z-3"
                          >
                            <!-- Header -->
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <h6 class="mb-0 text-muted small">Booking History</h6>
                              <button class="btn-close btn-sm" @click="calendar_popover_id = null"></button>
                            </div>

                            <!-- Booking History -->
                            <div class="small overflow-auto max-h-200">
                              <div
                                v-for="history in group.all"
                                :key="history.id"
                                class="d-flex justify-content-between align-items-start border-bottom py-2"
                              >
                                <div class="pe-2">
                                  <div>{{ history.booking_start_date }}</div>
                                  <div class="text-muted small">
                                    {{ formatTime(history.booking_start_time) }} - {{ formatTime(history.booking_end_time) }}
                                  </div>
                                </div>
                                <span
                                  class="badge text-capitalize align-self-start"
                                  :class="{
                                    'bg-primary': history.status.toLowerCase() === 'booked',
                                    'bg-success': history.status.toLowerCase() === 'completed',
                                    'bg-warning': ['in progress', 'pending'].includes(history.status.toLowerCase()),
                                    'bg-danger': ['cancelled', 'rejected'].includes(history.status.toLowerCase()),
                                  }"
                                >
                                  {{ history.status }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>

                      <!-- Status & Actions -->
                      <div class="col-md-4 text-center text-md-end">
                        <div class="d-flex justify-content-center justify-content-md-end align-items-center gap-2 mb-3">
                          <span
                            class="badge px-3 py-2 rounded text-xxs"
                            :class="{
                              'bg-primary': group.latest.status.toLowerCase() === 'booked',
                              'bg-success': group.latest.status.toLowerCase() === 'completed',
                              'bg-warning': ['in progress', 'pending'].includes(group.latest.status.toLowerCase()),
                              'bg-danger': ['cancelled', 'rejected'].includes(group.latest.status.toLowerCase()),
                            }"
                          >
                            <i
                              class="bi me-1"
                              :class="{
                                'bg-primary': group.latest.status.toLowerCase() === 'booked',
                                'bg-success': group.latest.status.toLowerCase() === 'completed',
                                'bg-warning': ['in progress', 'pending'].includes(group.latest.status.toLowerCase()),
                                'bg-danger': ['cancelled', 'rejected'].includes(group.latest.status.toLowerCase()),
                              }"
                            ></i>
                            {{ group.latest.status.charAt(0).toUpperCase() + group.latest.status.slice(1) }}
                          </span>

                          <button
                            v-if="group.latest.status.toLowerCase() === 'booked'"
                            class="btn btn-outline-danger btn-sm text-xxs rounded"
                            @click="cancel_booking(group.latest.id)"
                          >
                            <i class="bi bi-x-circle me-1"></i>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!-- /row g-3 -->
          </div>
          <!-- /bookings list -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Community Asset Modal -->
<div
  class="modal fade"
  id="create_community_asset_modal"
  tabindex="-1"
  aria-labelledby="createCommunityAssetLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="communityAssetModalLabel">
          {{ isEditing ? 'Edit Community Asset' : 'Create Community Asset' }}
        </p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <form @submit.prevent="isEditing ? updateCommunityAsset() : createcommunity_asset()">
        <div class="modal-body">
          <div class="mb-3">
            <label for="asset_name" class="form-label text-xxs fw-500">Asset Name<span class="text-danger">*</span></label>
            <input
              type="text"
              id="asset_name"
              class="form-control rounded text-xxs"
              v-model="asset_name"
              required
            />
            <div v-if="errors.community_asset_name" class="text-danger text-xxs mt-1">
              {{ errors.community_asset_name }}
            </div>
          </div>

          <div class="mb-3">
            <label for="description" class="form-label text-xxs fw-500">Description</label>
            <textarea
              id="description"
              class="form-control rounded text-xxs"
              rows="3"
              v-model="description"
            ></textarea>
          </div>

          <div class="mb-3">
            <label for="location" class="form-label text-xxs fw-500">Location<span class="text-danger">*</span></label>
            <input
              type="text"
              id="location"
              class="form-control rounded text-xxs"
              v-model="location"
              required
            />
          </div>

          <div class="mb-3">
            <label for="category_id" class="form-label text-xxs fw-500">Category<span class="text-danger">*</span></label>
            <select
              id="category_id"
              class="form-select rounded text-xxs"
              v-model="category_id"
              required
            >
              <option value="" disabled>Select a category</option>
              <option
                v-for="category in community_asset_categories"
                :key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
            <label @click="triggerFileInput" class="text-xxs text-secondary fw-500 border-0 rounded btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
              <i class='bx bx-image-add file-upload-icon'></i> Add Asset content
            </label>

            <input type="file" id="fileInput" ref="fileInput" class="d-none" @change="handleAssetFileUpload" />

            <div v-if="asset_file_name" class="text-xxs text-secondary fst-italic mt-1">
              <span class="fw-500">File name:</span> {{ asset_file_name }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xxs rounded">
            {{ isEditing ? 'Update Asset' : 'Save Asset' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="modal fade" id="assetModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500">{{ selected_asset.name }}</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body modal-body-scroll">
        <div class="row">
          <div class="col-md-6 d-block">
            <p class="text-xxs"><strong>Description:</strong> <span v-html="selected_asset.description"></span></p>
            <p class="text-xxs"><strong>Location:</strong> {{ selected_asset.location }}</p>
          </div>
          <div class="col-md-6">
            <div class="card bg-transparent border-2 rounded">
              <div
                v-if="selected_asset.community_asset_files && selected_asset.community_asset_files.length"
                class="d-flex flex-column align-items-start position-relative"
              >
                <img
                  v-if="selected_asset.community_asset_files[0].file.file_url.includes('.jpg') ||
                        selected_asset.community_asset_files[0].file.file_url.includes('.png')  ||
                        selected_asset.community_asset_files[0].file.file_url.includes('.jpeg')"
                  :src="selected_asset.community_asset_files[0].file.file_url"
                  alt="Community Asset Image"
                  class="img-fluid rounded my-3 w-100"
                />
              </div>

              <!-- My Bookings for this asset -->
              <div v-if="booked_slots.filter(b => b.status.toLowerCase() === 'booked').length > 0">
                <!-- Header row: left title, right status badge -->
                <div class="d-flex justify-content-between align-items-center mt-2 px-3">
                  <p class="fw-bold text-xxs">Your bookings:</p>
                  <span class="badge rounded text-xxs bg-primary">Booked</span>
                </div>

                <div class="row">
                  <div
                    v-for="booking in booked_slots.filter(b => b.status.toLowerCase() === 'booked')"
                    :key="booking.id"
                    class="col-12"
                  >
                    <div class="card shadow-sm border-0 h-100">
                      <div class="card-body">
                        <div class="row align-items-center">
                          <!-- Date & Time (left) -->
                          <div class="col-md-6 mb-3 mb-md-0">
                            <div class="text-center text-md-start text-xxs">
                              <div class="mb-2">
                                <i class="bi bi-calendar3 text-muted me-2"></i>
                                <span class="fw-medium">{{ booking.booking_start_date }}</span>
                              </div>
                              <div>
                                <i class="bi bi-clock text-muted me-2"></i>
                                <span class="text-muted small">
                                  {{ formatTime(booking.booking_start_time) }} - {{ formatTime(booking.booking_end_time) }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <!-- Actions (right) — aligned to far right to line up with time row -->
                          <div class="col-md-6 d-flex justify-content-md-end justify-content-center align-items-center gap-2">
                            <button
                              v-if="booking.status.toLowerCase() === 'booked'"
                              class="btn btn-outline-danger btn-sm text-xxs rounded"
                              @click="cancel_booking(booking.id)"
                            >
                              <i class="bi bi-x-circle me-1"></i>
                              Cancel
                            </button>
                          </div>
                        </div> <!-- /row -->
                      </div> <!-- /card-body -->
                    </div> <!-- /card -->
                  </div>
                </div>
              </div>

              <!-- No bookings fallback -->
              <div v-else>
                <p class="text-xxs">You have no bookings yet.</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="modal-footer justify-content-end">
        <button class="d-none btn btn-warning btn-lg text-white text-xxs rounded shadow-lg fw-500"
          v-if="!selected_asset.subscribed" :id="'subscribe-button-' + selected_asset.id"
          @click="subscribeCommunityAsset(selected_asset)">Subscribe</button>
        <button class="btn btn-warning btn-lg text-white text-xxs rounded shadow-lg fw-500"
          v-if="selected_asset.subscribed" :id="'subscribed-button-' + selected_asset.id"
          @click="unsubscribeCommunityAsset(selected_asset)">Unsubscribe</button>
        <button class="btn btn-primary text-white text-xxs rounded shadow-lg fw-500"
          @click="openBookingModal(selected_asset)">
          Book Now
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <FloatingButtonComponent  /> -->

<div class="modal fade" id="bookingModal" tabindex="-1" aria-labelledby="bookingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="bookingModalLabel">Book Asset</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <form @submit.prevent="submit_booking">
        <div class="modal-body">
          <p class="text-xxs"><strong>Asset:</strong> {{ booking_asset.name }}</p>
          <div class="mb-3">
            <label class="form-label text-xxs fw-500">Booking Date <span class="text-danger">*</span></label>
              <input
              type="date"
              class="form-control rounded text-xxs"
              v-model="booking_start_date"
              :min="new Date().toISOString().split('T')[0]"
              required
            />
            <div v-if="show_date_error" class="invalid-feedback d-block text-xxs">
              Please select a date before choosing a time slot.
            </div>
          </div>

        <div class="mb-3">
          <label class="form-label text-xxs fw-500">Select Time Slot<span class="text-danger">*</span></label>
                    <div class="time-slot-grid">
            <div
              v-for="(time, index) in generateFullTimeSlots()"
              :key="index"
              :class="get_slot_class(time)"
              @click="toggle_time_selection(time)"
            >
              {{ formatTime(time) }}
            </div>
          </div>
        </div>

          <div class="mb-3">
            <label class="form-label text-xxs fw-500">Reason for Booking<span class="text-danger">*</span></label>
            <textarea
              class="form-control rounded-4 text-xxs"
              rows="3"
              placeholder="Enter reason for booking..."
              v-model="booking_reason"
              required
            ></textarea>
          </div>

        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary btn-sm text-xxs rounded" :disabled="booking_submitting || booking_ranges.length === 0">
            <span v-if="booking_submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ booking_submitting ? 'Booking...' : 'Confirm Booking' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="bookingsListModal" tabindex="-1" aria-labelledby="bookingsListModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="bookingsListModalLabel">
          {{ selected_asset.name }} - Bookings
        </p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div v-if="booked_slots.length">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Booking Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Reason</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="booking in booked_slots" :key="booking.id">
                  <td class="fw-semibold">{{ booking.user.profile_name }}</td>
                  <td>{{ booking.booking_start_date }}</td>
                  <td><code class="text-dark">{{ formatTime(booking.booking_start_time) }}</code></td>
                  <td><code class="text-dark">{{ formatTime(booking.booking_end_time) }}</code></td>
                  <td>{{ booking.booking_reason || '—' }}</td>
                  <td>
                    <span v-if="(current_role !== 'admin' && selected_asset.creater?.id !== current_user_id) || booking.status.toLowerCase() !== 'pending'" class="badge"
                      :class="{
                        'bg-primary': booking.status.toLowerCase() === 'booked',
                        'bg-success': booking.status.toLowerCase() === 'completed',
                        'bg-warning': ['in progress'].includes(booking.status.toLowerCase()),
                        'bg-danger': ['cancelled', 'rejected'].includes(booking.status.toLowerCase()),
                      }">
                      {{ booking.status }}
                    </span>
                    <div
                    v-if="(current_role === 'admin' || selected_asset.creater?.id === current_user_id) && booking.status.toLowerCase() === 'pending'"
                    class="mt-2 d-flex gap-1"
                  >
                    <span @click="approve_booking(booking.id)"
                      class="badge bg-success text-white text-decoration-none pointer"
                    >
                      Approve
                    </span>
                    <span @click="reject_booking(booking.id)"
                      class="badge bg-danger text-white text-decoration-none pointer"
                    >
                      Reject
                    </span>
                  </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="text-center text-muted py-5">
          <h6>No bookings found for this asset.</h6>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer bg-light">
        <small class="text-muted me-auto">
          Total: {{ booked_slots.length }} booking(s)
        </small>
        <button
          @click="export_bookings_CSV"
          class="btn btn-primary btn-sm text-xxs rounded">
          Export CSV
        </button>
      </div>

    </div>
  </div>
</div>
